import React, { useState } from 'react';
import Layout from './Layout';

const Contact = () => {
	const [result, setResult] = useState('');
	const [sending, setSending] = useState(false);

	const onSubmit = async (event) => {
		event.preventDefault();
		setSending(true);
		setResult('Sending...');

		const formData = new FormData(event.target);
		formData.append('access_key', '6b402db3-6f61-4972-ae02-a802e0cd8c63');
		formData.append('subject', 'CraftersPro Contact Form');
		formData.append('from_name', 'CraftersPro');

		try {
			const response = await fetch('https://api.web3forms.com/submit', {
				method: 'POST',
				body: formData,
			});
			const data = await response.json();
			if (data.success) {
				setResult('Thanks! We will reply shortly.');
				event.target.reset();
			} else {
				setResult(data.message || 'Something went wrong. Please try again.');
			}
		} catch (err) {
			setResult('Something went wrong. Please try again.');
		} finally {
			setSending(false);
		}
	};

	const fieldStyle = {
		width: '100%',
		border: '1px solid #cfd8dc',
		borderRadius: 4,
		padding: '12px 14px',
		fontSize: 15,
		marginBottom: 16,
	};

	return (
		<Layout>
			<div role='main' className='main' style={{ paddingTop: 140 }}>
				<div className='row mb-4'>
					<h3
						className='font-weight-bold text-6 center primary-color font-primary-bold'
						data-appear-animation='fadeInDown'
						data-appear-animation-delay='100'>
						Contact Us
					</h3>
				</div>

				<div className='contact mt-32' style={{ height: 'auto', paddingBottom: 40 }}>
					<form onSubmit={onSubmit} style={{ maxWidth: 560, margin: '0 auto', padding: '0 16px' }}>
						<input type='checkbox' name='botcheck' style={{ display: 'none' }} tabIndex='-1' autoComplete='off' />
						<div>Name</div>
						<input type='text' name='name' required style={fieldStyle} />
						<div>Email</div>
						<input type='email' name='email' required style={fieldStyle} />
						<div>Message</div>
						<textarea name='message' required style={{ ...fieldStyle, minHeight: 140 }} />
						<button
							className='tp-caption btn btn-secondary font-primary-regular'
							style={{ width: '100%', justifyContent: 'center' }}
							disabled={sending}
							type='submit'>
							{sending ? 'Sending...' : 'Submit'}
						</button>
						<p className='text-center' style={{ marginTop: 14 }}>{result}</p>
					</form>
				</div>
			</div>
		</Layout>
	);
};

export default Contact;
